import { components } from 'type/ReportServiceSchema';

export type PerspectiveStatusDto = components['schemas']['PerspectiveStatus'];

export enum PerspectiveStatusModel {
  Pending = 'Pending',
  Failed = 'Failed',
  Completed = 'Completed',
}

export const mapPerspectiveStatusDtoToModel = (
  dto: PerspectiveStatusDto
): PerspectiveStatusModel => {
  switch (dto) {
    case 'Pending':
      return PerspectiveStatusModel.Pending;
    case 'Failed':
      return PerspectiveStatusModel.Failed;
    case 'Completed':
      return PerspectiveStatusModel.Completed;
    default:
      throw new Error(`Unknown PerspectiveStatus: ${dto}`);
  }
};
